// import { message } from 'antd';
import { create } from 'zustand';

import { type IHomepageData, getHomepage } from '@/service/homePage';

interface IHomePageStore {
  homePage: IHomepageData | null;
  fetchHomepage: (route: string) => Promise<void>;
  updateHomepage: (data: Record<string, any>) => void;
}

export const useHomePageStore = create<IHomePageStore>((set, get) => ({
  homePage: null,
  fetchHomepage: (route: string) =>
    getHomepage({ route })
      .then((res) => {
        if (res.data.code !== 0) {
          throw new Error(res.data.message);
        }

        const homePage = res.data.data;
        const _homePage = get().homePage;

        set({ homePage: { ..._homePage, ...homePage } });
      })
      .catch((error) => {
        console.error(error);
        // message.error(error?.message);
      }),
  updateHomepage: (data: Record<string, any>) => {
    const _homePage = get().homePage;

    set({ homePage: { ..._homePage, ...data } });
  }
}));
